<template>
	<div :style="backgroundUrl">
		<!-- Navbar -->
		<nav id="navbar-main" class="navbar navbar-horizontal navbar-transparent navbar-main navbar-expand-lg">
			<div class="container">
				<router-link class="navbar-brand" to="/">
					<img src="assets/img/brand/eThinking-pro.png" v-if="hostname == 'pro.etciberoamerica.com' || hostname == 'bpo.etciberoamerica.com'">
					<img src="assets/img/brand/eThinking-pro-white.png" v-if="hostname == 'seducoahuila.etciberoamerica.com' || hostname == 'conalep-tamps.etciberoamerica.com' || hostname == 'conalep-gto.etciberoamerica.com' || hostname == 'conalep-ags.etciberoamerica.com' || hostname == 'conalep-on.etciberoamerica.com' || this.hostname == 'itsloscabos.etciberoamerica.com' || this.hostname == 'conalep-chihuahua.etciberoamerica.com' || this.hostname == 'canacintra.etciberoamerica.com' || this.hostname == 'conalep-qro.etciberoamerica.com'">
				</router-link>
			</div>
		</nav>
		<!-- Main content -->
		<div class="main-content">
			<!-- Header -->
			<div class="header py-7 py-lg-7 pt-lg-9">
				<div class="container">
					<div class="header-body text-center mt--5 mb-5">
						<div class="row justify-content-center">
							<div class="col-xl-5 col-lg-6 col-md-8 px-5">
								<h1 style="font-weight:200">Bienvenidos</h1>

							</div>
						</div>
					</div>
				</div>

			</div>
			<!-- Page content -->
			<div class="container mt--8 pb-5">
				<div class="row justify-content-center">
					<div class="col-lg-5 col-md-7">
						<div :class="classLogin">

							<div class="card-body px-lg-5 py-lg-5">
								<div :class="classUsuario">
									<img src="assets/img/bpo-academy-white-sm.png" class="mx-auto mb-4" v-if="hostname == 'bpo.etciberoamerica.com'"><br v-if="hostname == 'bpo.etciberoamerica.com'">
									<img src="assets/img/seducoahuila_logo.png" class="mx-auto mb-4" v-if="hostname == 'seducoahuila.etciberoamerica.com'">
									<img src="assets/img/IPSPPEGEM.jpg" class="mx-auto mb-4" v-if="hostname == 'iproedomex.etciberoamerica.com'" width="350px"><br v-if="hostname == 'bpo.etciberoamerica.com' || hostname == 'seducoahuila.etciberoamerica.com' || hostname == 'iproedomex.etciberoamerica.com' || hostname == 'conalep-tamps.etciberoamerica.com' || hostname == 'conalep-gto.etciberoamerica.com' || hostname == 'conalep-ags.etciberoamerica.com' || hostname == 'tesecatepec.etciberoamerica.com'  || hostname == 'conalep-ver.etciberoamerica.com' || hostname == 'conalep-yuc.etciberoamerica.com'  || hostname == 'conalep-on.etciberoamerica.com' || this.hostname == 'itsloscabos.etciberoamerica.com' || this.hostname == 'conalep-chihuahua.etciberoamerica.com' || this.hostname == 'canacintra.etciberoamerica.com' || this.hostname == 'conalep-qro.etciberoamerica.com'">
									<img src="assets/img/logo_ctm.png" class="mx-auto mb-4" v-if="hostname == 'ctm.etciberoamerica.com'">
									<img src="assets/img/logouat.jpeg" class="mx-auto mb-4" v-if="hostname == 'ipnpro.etciberoamerica.com'" width="200">
									<img src="assets/img/logo_plai.png" class="mx-auto mb-4" v-if="hostname == 'tnmpro.etciberoamerica.com'" width="200">
									<img src="assets/img/logo_tecnm_old.png" class="mx-auto mb-4" v-if="hostname == 'tecnm.etciberoamerica.com'" width="200">
									<img src="assets/img/brand/eThinking-pro.png" class="mx-auto mb-4" v-if="hostname == 'dgo-pro.etciberoamerica.com'" width="200">
									<img src="assets/img/conalep_logo_gral.png" class="mx-auto mb-4" v-if="hostname == 'conapro.etciberoamerica.com'" width="200">
									<img src="assets/img/logo_uaem.png" class="mx-auto mb-4" v-if="hostname == 'uaempro.etciberoamerica.com'" width="200">
									<img src="assets/img/CNLEDOMEXLOGO.png" class="mx-auto mb-4" v-if="hostname == 'conalep-edomex.etciberoamerica.com'" width="200">
									<img src="assets/img/UAS.jpeg" class="mx-auto mb-4" v-if="hostname == 'uas-pro.etciberoamerica.com'" width="200"><br>
									<img src="assets/img/logo-conalep-tamps.png" class="mx-auto mb-4" v-if="hostname == 'conalep-tamps.etciberoamerica.com'" width="200"><br>
									
									<img src="assets/img/logo_conalep_gto.png" class="mx-auto mb-4" v-if="hostname == 'conalep-gto.etciberoamerica.com'" width="200"><br>
									<img src="assets/img/logo_conalep_ags.jpg" class="mx-auto mb-4" v-if="hostname == 'conalep-ags.etciberoamerica.com'" width="200"><br>
									<img src="assets/img/logo_tes_ecatepec.png" class="mx-auto mb-4" v-if="hostname == 'tesecatepec.etciberoamerica.com'" width="200"><br>
									<img src="assets/img/logo-conalep-ver.png" class="mx-auto mb-4" v-if="hostname == 'conalep-ver.etciberoamerica.com'" width="200"><br>
									<img src="assets/img/logo-conalep-yuc.png" class="mx-auto mb-4" v-if="hostname == 'conalep-yuc.etciberoamerica.com'" width="200"><br>
									<img src="assets/img/conalep-logo.png" class="mx-auto mb-4" v-if="hostname == 'conalep-on.etciberoamerica.com'" ><br>
									<img src="assets/img/its-cabos-logo.jpg" class="mx-auto mb-4" v-if="hostname == 'itsloscabos.etciberoamerica.com'" ><br>
									<img src="assets/img/conalep-chihuahua-logo.jpg" class="mx-auto mb-4" v-if="hostname == 'conalep-chihuahua.etciberoamerica.com'" ><br>
									<img src="assets/img/canacintra-logo.jpg" class="mx-auto mb-4" v-if="hostname == 'canacintra.etciberoamerica.com'" ><br>
									<img src="assets/img/conalep-qro-logo.jpg" class="mx-auto mb-4" v-if="hostname == 'conalep-qro.etciberoamerica.com'" ><br>
									<small v-if="hostname != 'ctm.etciberoamerica.com'">Usuario registrado</small>
								</div>
								<vue-form :state="formstate" @submit.prevent="onSubmit">
									<div class="form-group mb-3">
										<validate tag="div">
											<div class="input-group input-group-merge input-group-alternative">
												<div class="input-group-prepend">
													<span class="input-group-text"><i class="ni ni-email-83"></i></span>
												</div>
												<input class="form-control" placeholder="Correo electrónico" type="email" name="email" id="email" v-model="model.email" required>
											</div>
											<field-messages name="email" show="$invalid && $submitted" class="text-danger">
	                                            <div slot="required">El correo electrónico es requerido</div>
	                                            <div slot="email">El correo electrónico no es válido</div>
	                                        </field-messages>
										</validate>
									</div>
									<div class="form-group">
										<validate tag="div">
											<div class="input-group input-group-merge input-group-alternative">
												<div class="input-group-prepend">
													<span class="input-group-text"><i class="ni ni-lock-circle-open"></i></span>
												</div>
												<input class="form-control" placeholder="Contraseña" type="password" id="password" name="password" minlength="8" required v-model="model.password">
											</div>
											<field-messages name="password" show="$invalid && $submitted" class="text-danger">
	                                            <div slot="required">La contraseña es requerida</div>
	                                            <div slot="minlength">La contraseña debe ser al menos de 8 caracteres</div>
	                                        </field-messages>
										</validate>
									</div>
									<div class="form-group">
										<router-link to="/forgot-password" :class="classForgot">Olvidé mi contraseña</router-link>
									</div>
									<div class="custom-control custom-control-alternative custom-checkbox">
										<input class="custom-control-input" id=" customCheckLogin" type="checkbox">
										<label class="custom-control-label" for=" customCheckLogin">
											<span class="text-muted">Recordarme</span>
										</label>
									</div>
									<div class="text-center">
										<button type="submit" class="btn btn-neutral my-2">Iniciar sesión</button>
									</div>
									<div class="text-center">
										<router-link to="/register"><button type="button" class="btn btn-neutral my-2">Registrarme</button></router-link>
									</div>
								</vue-form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- Footer -->
		<!--<footer class="py-5" id="footer-main"  v-if="hostname == 'pro.etciberoamerica.com'">
			<div class="container">
				<div class="row align-items-center justify-content-xl-between">
					<div class="col-xl-4">
						<div class="copyright text-center text-xl-left text-muted">
							&copy; 2020 <a href="https://etciberoamerica.com/" class="font-weight-bold ml-1" target="_blank">ETC Iberoamérica</a>
						</div>
					</div>
					<div class="col-xl-4">

					</div>
				</div>
			</div>
		</footer>-->
	</div>
</template>
<script>
	import options from "../validations/validations.js";
	Vue.use(VueForm, options);
	export default {
		name: 'Index',
		data() {
			return {
				formstate: {},
	            model: {
	                email: "",
	                password: ""

				},
				hostname: '',
				backgroundUrl: 'background-image:url(assets/img/fondos/pro-login-bg.png); background-size:cover; background-repeat:no-repeat',
				classLogin: 'card bg-gradient-default',
				classUsuario: 'text-center text-muted mb-4',
				classForgot: 'text-white'
			}
		},
		methods: {
			onSubmit() {
				if (this.formstate.$invalid) {
	                return;
	            } else {
	            	this.openLoading()
	            	axios.post(apiKS + 'api/login', this.model)
	            	.then( response => {
	            		if(response.data.id == 0 && response.data.token == '') {
	                        Swal.close()
	                        Swal.fire({
					        	icon: 'error',
					        	title: 'Oops...',
					        	text: response.data.message,
					        })
	                    }
	                    if(response.data.id > 0 && response.data.token != '') {
	                        Swal.close()
	                        localStorage.tokenETCSistema = 'Bearer ' + response.data.token
	                        headers = {
	                            'Content-Type': 'application/json',
	                            Authorization: localStorage.tokenETCSistema
	                        }
	                        axios.get(apiKS + 'api/user', { headers })
	                        .then( response => {
	                            localStorage.userETC = response.data.userEncrypted
	                            axios.post(apiKS + 'api/userdecrypt', {usuario: localStorage.userETC}, { headers })
	                            .then( response => {
									user = JSON.parse(response.data.user)
									if(user.tipo_usuario_pro == 1) 
										router.push('/home')
									if(user.tipo_usuario_pro == 2) 
										router.push('/home-teacher')
	                            }).catch(error => {
	                                this.catchError(error)
	                            })
	                        })
	                    }
	            	}).catch(error => {
	            		this.catchError()
	            	})
	            }
			}
		},
		mounted() {
			this.hostname = hostname

			const script = document.createElement('script')
			script.src = 'assets/js/argon.js'
			document.body.appendChild(script)

			if(localStorage.tokenETCSistema) {
	            if(this.$route.query.logout == 1) {
	                axios.get(apiKS + 'api/logout', { headers })
	                .then(response => {
	                    if(response.data.status == true) {
	                        localStorage.removeItem("tokenETCSistema")
	                        localStorage.removeItem("userETC")
	                    }
	                }).catch(error => {
	                    this.catchError(error)
	                })
	            }else{
	                headers = {
	                    'Content-Type': 'application/json',
	                    Authorization: localStorage.tokenETCSistema
	                }
	                axios.post(apiKS + 'api/userdecrypt', {usuario: localStorage.userETC}, { headers })
	                .then( response => {
						user = JSON.parse(response.data.user)
						if(user.tipo_usuario_pro == 1) 
							router.push('/home')
						if(user.tipo_usuario_pro == 2) 
	                    	router.push('/home-teacher')
	                }).catch(error => {
	                    this.catchError(error)
	                })
	            }
	        }
		},
		beforeMount() {
			//document.body.classList.remove('bg-mos1')
			if(hostname == 'bpo.etciberoamerica.com') {
				this.backgroundUrl = 'background-image:url(assets/img/fondos/bpo-academy-bg.jpg); background-size:cover; background-repeat:no-repeat'
				this.classLogin = 'card bg-gradient-gray-dark'
				this.classUsuario = 'text-center text-orange mb-4'
			}
			if(hostname == 'seducoahuila.etciberoamerica.com' || hostname == 'iproedomex.etciberoamerica.com' || hostname == 'ctm.etciberoamerica.com' || hostname == 'ipnpro.etciberoamerica.com' || hostname == 'tnmpro.etciberoamerica.com' || hostname == 'conapro.etciberoamerica.com' || hostname == 'uaempro.etciberoamerica.com' || hostname == 'tecnm.etciberoamerica.com' || hostname == 'dgo-pro.etciberoamerica.com' || hostname == 'conalep-edomex.etciberoamerica.com' || hostname == 'uas-pro.etciberoamerica.com' || hostname == 'conalep-tamps.etciberoamerica.com' || hostname == 'conalep-gto.etciberoamerica.com' || hostname == 'conalep-ags.etciberoamerica.com' || hostname == 'tesecatepec.etciberoamerica.com' || hostname == 'conalep-ver.etciberoamerica.com' || hostname == 'conalep-yuc.etciberoamerica.com' || hostname == 'conalep-on.etciberoamerica.com' || this.hostname == 'itsloscabos.etciberoamerica.com' || this.hostname == 'conalep-chihuahua.etciberoamerica.com' || this.hostname == 'canacintra.etciberoamerica.com' || this.hostname == 'conalep-qro.etciberoamerica.com') {
				this.backgroundUrl = 'background-image:url(assets/img/fondos/seducoahuila-bg.jpg); background-size:cover; background-repeat:no-repeat'
				this.classLogin = 'card bg-light'
				this.classUsuario = 'text-center text-purple mb-4'
				this.classForgot = 'text-purple'
			}
		}
	}
</script>